export default __webpack_public_path__ + "static/hero-img-d372824459454dd39a38794e5b87bf2a.jpg";